export default "__VITE_ASSET__B61f7ia9__"